<template>
  <div class="hosIndex" v-loading="loading">
    <NewHeader></NewHeader> 
    <!-- 导航 -->
    <div class="navigation">
      <div>
        <span class="color-blue cur-pointer" @click="$router.push({path:'/'})">首页</span>
        &nbsp;&nbsp;/&nbsp;&nbsp;{{ hosMsg.hospitalData && hosMsg.hospitalData.HOS_NAME}}
      </div>
    </div>
    <!-- 医院头部 -->
    <div class="hos-head">
      <div>
        <img :src="hosMsg.hospitalData && hosMsg.hospitalData.HOS_PHOTO" alt />
        <div>
          <div class="dis-flex">
            <div>
              <span>{{hosMsg.hospitalData && hosMsg.hospitalData.HOS_NAME}}</span>
              <span>{{ hosMsg.hospitalData && hosMsg.hospitalData.HOS_LEVEL.replace(/null/g, '') }}</span>
            </div>
            <!-- <div><span class="color-blue font-s-16">0</span>&nbsp;&nbsp;人已预约&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="color-red  font-s-16">1</span>&nbsp;&nbsp;人已关注</div> -->
          </div>
          <div>医院简介</div>
          <div class="line-clamp-3" v-html="hosMsg.hospitalData && hosMsg.hospitalData.HOS_DESC != '' ? hosMsg.hospitalData.HOS_DESC: '<p>暂无简介</p>'"></div>
          <span>
            <!-- <a href="#">查看详情>></a> -->
          </span>

          <!-- <div>
            <div>更多&nbsp;&nbsp;<img src="../assets/img/hosIndex/jiantou.png" alt=""></div>
            <div>
              <div class="dis-flex"><img src="../assets/img/hosIndex/seeImage.png" alt=""><div>影像查询</div></div>
              <div class="dis-flex"><img src="../assets/img/hosIndex/follow.png" alt=""><div>关注医院</div></div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
    <!-- 医院信息 -->
    <div class="hos-content">
      <div>
        <div class="tabs">
          <div :class="{'active':type==1}" @click="tabsBtn(1)">主页</div>
          <div :class="{'active':type==2}" @click="tabsBtn(2)">医院简介</div>
        </div>
        <transition name="fade">
          <div class="hos-main" v-show="type==1">
            <div class="hos-main-left">
              <div class="title" v-show="hosMsg.hotExpertList && hosMsg.hotExpertList.length>0">
                科室列表
                <div class="more">
                  更多&nbsp;&nbsp;
                  <img src="../assets/img/hosIndex/jiantou.png" alt />
                </div>
              </div>
              <div class="dept-list" v-show="hosMsg.deptData != ''">
                <div>
                  <span class="dept-title">医学影像科</span>
                  <span class="dept-name"></span>
                  <span class="dept-data">{{ hosMsg.deptData && hosMsg.deptData.thisDeptCound }}</span>
                </div>
                <div>
                  <span class="dept-title">其他</span>
                  <span class="dept-name"></span>
                  <span
                    class="dept-data"
                  >{{  hosMsg.deptData && hosMsg.deptData.interDeptCound ? hosMsg.deptData && hosMsg.deptData.interDeptCound : 0 }}</span>
                </div>

                <div class="center-line"></div>
              </div>
              <div class="title" v-show="hosMsg.hotExpertList && hosMsg.hotExpertList.length>0">
                热门专家
                <!-- <div class="more">
                  更多&nbsp;&nbsp;
                  <img src="../assets/img/hosIndex/jiantou.png" alt />
                </div> -->
              </div>
              <div>
                <div class="doc-list" v-show="hotDoctorList && hotDoctorList.length>0">
                  <div class="cur-pointer" v-for="hot in hotDoctorList" @click="toDoctor(hot)">
                    <img
                      class="cur-pointer"
                      :src="hot.DOC_PHOTO"
                      @error="docNoError(hot,'DOC_PHOTO')"
                    />
                    <div>
                      <span class="color-blue font-s-16 cur-pointer">{{hot.DOC_NAME}}</span>&nbsp;&nbsp;&nbsp;
                      <span>{{hot.DOC_TITLE}}</span>
                    </div>
                    <div class="font-s-12">{{hot && hot.hos_name}}</div>
                    <!-- <div class="font-s-12">擅长：小儿疾病 呼吸科</div> -->
                  </div>
                </div>
                <div class="page-list" v-show="total > 9">
                        <el-pagination
                            :current-page.sync="currentPage"
                            :page-size="9"
                            :total="total"
                            background
                            layout="total, prev, pager, next"
                            @current-change="formateHotDoctorList"
                        ></el-pagination>
                </div>
              </div>
              <div class="clear-both"></div>
              <div class="title" v-show="hosMsg.CooEXpertList && hosMsg.CooEXpertList.length>0">
                <!-- <div class="title" v-show=""> -->
                合作医生
                <!-- <div class="more">
                  更多&nbsp;&nbsp;
                  <img src="../assets/img/hosIndex/jiantou.png" alt />
                </div> -->
              </div>
              <div class="doc-list" v-show="hosMsg.CooEXpertList && hosMsg.CooEXpertList.length>0">
                <!-- <div class="doc-list" v-show=""> -->
                <div class="cur-pointer" v-for="coo in hosMsg.CooEXpertList" @click="toDoctor(coo)">
                  <img
                    :src="coo.DOC_PHOTO"
                    @error="docNoError(coo,'DOC_PHOTO')"
                    class="cur-pointer"
                  />
                  <div>
                    <span class="color-blue font-s-16 cur-pointer">{{coo.DOC_NAME}}</span>
                  </div>
                  <div class="font-s-12">{{coo.DOC_TITLE}}</div>
                  <div class="font-s-12">{{coo && coo.hos_name}}</div>
                </div>
              </div>
              <div class="clear-both"></div>
            </div>
            <div class="hos-main-right">
              <!-- <div class="hos-search">
              <div class="hos-right-head">本院搜索</div>
              <div class="content"></div>
              </div>-->
              <div class="hos-navigation">
                <div class="hos-right-head">医院导航</div>
                <div class="content">
                  <div>电话：{{hosMsg.hospitalData && hosMsg.hospitalData.HOS_TEL}}</div>
                  <div>
                    官网：
                    <a :href="hosMsg.hospitalData && hosMsg.hospitalData.HOS_URL">{{hosMsg.hospitalData && hosMsg.hospitalData.HOS_URL}}</a>
                  </div>
                  <div>地址：{{hosMsg.hospitalData && hosMsg.hospitalData.HOS_ADDR}}</div>
                  <div class="map" id="container"></div>
                </div>
              </div>
              <div class="hos-cooperation" v-show="hosMsg.cooHospitalList && hosMsg.cooHospitalList.length!=0">
                <div class="hos-right-head">合作医院</div>
                <div class="content">
                  <!-- <div v-for="cooHospital in hosMsg.cooHospitalList"></div> -->
                  <div
                    class="cur-pointer"
                    v-for="cooHospital in cooHospitalList"
                    @click="refreshPage(cooHospital)"
                  >{{cooHospital && cooHospital.HOS_NAME}}</div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </transition>
        <!-- 
        
        -->
        <transition name="myfade">
          <div v-show="type==2">
            <div class="hos-HOS_DESC" v-html="hosMsg.hospitalData && hosMsg.hospitalData.HOS_DESC != '' ? hosMsg.hospitalData.HOS_DESC: '<p>暂无简介</p>'"></div>
          </div>
        </transition>
      </div>
    </div>
    <!-- 底部 -->
    <NewFooter></NewFooter>
  </div>
</template>
<script>
import BMap from "BMap";
// @ is an alias to /src
import NewHeader from "@/components/NewHeader.vue";
import NewFooter from "@/components/NewFooter.vue";
import doc from "../assets/img/index/doc1.png";
export default {
  name: "hosIndex",
  data() {
    return {
      docName: "",
      loading: false,
      type: 1,
      hosMsg: {},
      currentPage: 1,
      total: 0,
      CooEXpertList: [],
      cooHospitalList: [],
      hospitalData: {},
      hotExpertList: [],
      hotDoctorList:[]
    };
  },
  components: {
    NewFooter,
    NewHeader
  },
  methods: {
    docNoError(d, name) {
      //图片error处理
      d[name] = doc;
    },

    // getOnline() {
    //   if (sessionStorage.getItem('sessionId')) {
    //     var params = new URLSearchParams();
    //     params.append("sessionId", sessionStorage.getItem('sessionId'));
    //     this.$ajax
    //       .post("getSessionIdIsExist", params)
    //       .then(response => {
    //         if (response.result) {
    //           this.docName = response.user.n;
    //         }
    //       })
    //       .catch(error => {});
    //   }
    // },

    // 合作医院点击：
    refreshPage(item) {
      console.log(item.HOSPITAL_ID);
      this.loading = true;
      this.$router.push({
        path: "/hosIndex",
        query: { organ_id: item.HOSPITAL_ID }
      });

      // this.$router.go(0);
    },

    // 合作医生点击
    toDoctor(item) {
      let that = this;
      console.log("合作医生", item);
      that.$router.push({ path: "/docIndex", query: { id: item.DOCTOR_ID } });
    },

    logout() {
      var params = new URLSearchParams();
      params.append("sessionId", sessionStorage.getItem('sessionId'));
      this.$ajax
        .post("logout", params)
        .then(response => {
          if (response.result) {
            this.docName = "";
            sessionStorage.removeItem('sessionId');
            this.$common.removeCookie("token");
          }
          this.codeBtn();
        })
        .catch(error => {});
    },
    getParams() {
      let that = this;
      let params = new URLSearchParams();
      if (
        that.$route.query.organ_id != "" &&
        that.$route.query.organ_id != undefined
      ) {
        params.append("organ_id", that.$route.query.organ_id);
      } else {
        params = {};
      }
      return params;
    },

    isNull(params) {
      if (params == null) {
        return (params = []);
        console.log("改革");
      } else {
        return params;
      }
    },

    formateHotDoctorList(index){
      console.log('index--',index);
      if(this.hotExpertList.length > 0){
        this.hotDoctorList = this.hotExpertList.slice(9*(index-1), 9*(index-1)+9)
        console.log('this.hotDoctorList--',this.hotDoctorList);
      }
    },
    getHos() {
      let that = this;
      this.loading = true;
      let params = that.getParams();
      this.$ajax
        .post("homePage/hospitalHomePage", params)
        .then(response => {
          this.loading = false;
          if (response.result) {
            that.hosMsg = response;
            console.log('response--',response);
            that.CooEXpertList = response.CooEXpertList;
            that.cooHospitalList = response.cooHospitalList;
            that.hospitalData = response.hospitalData;
            that.hotExpertList = response.hotExpertList;
            that.total = that.hotExpertList.length
            console.log('that.total--',that.total);
            that.formateHotDoctorList(1)
            setTimeout(() => {
              this.mapInit(
                response.hospitalData.MAP_LAT,
                response.hospitalData.MAP_LNG
              );
            });
          }
        })
        .catch(error => {
          this.loading = false;
        });
    },
    tabsBtn(d) {
      this.type = d;
    },
    mapInit(lat, lng) {
      // 创建Map实例
      var map = new BMap.Map("container");
      // 初始化地图,设置中心点坐标和地图级别
      map.centerAndZoom(new BMap.Point(lng, lat), 15);
      //添加地图类型控件
      map.addControl(
        new BMap.MapTypeControl({
          mapTypes: [BMAP_NORMAL_MAP, BMAP_HYBRID_MAP]
        })
      );
      // 设置地图显示的城市 此项是必须设置的
      map.setCurrentCity("莆田");
      //开启鼠标滚轮缩放
      map.enableScrollWheelZoom(true);
      /* eslint-enable */
      var map = new BMap.Map("container");
      var point = new BMap.Point(lng, lat);
      map.centerAndZoom(point, 16);
      var marker = new BMap.Marker(point);
      var mapPoints = [{ x: lng, y: lat }];
      var i = 0;
      map.addOverlay(marker);
      map.enableScrollWheelZoom(true);
    }
  },
  created() {
    // this.getOnline();
    this.getHos();
  },
  mounted() {},
  watch: {
    $route(to, from) {
      // this.getOnline();
      this.getHos();
    }
  }
};
</script>
<style  lang="stylus">
.page-list {
  .el-pagination {
    text-align: center;
    padding: 4.2rem 0.026316rem 0rem;
    .el-icon-arrow-left:before, .el-icon-arrow-right:before {
      // color: #0080CB;
      background-color: #EEEEEE;
      display: inline-block;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 18px;
    }
    .el-pagination__total {
      height: 32px;
      line-height: 32px;
      color: #0080CB;
      font-size: 14px;
      margin-left: 20px;
    }
    .el-pager {
      li {
        border-radius: 50%;
        min-width: 32px;
        min-height: 32px;
        line-height: 32px;
        color: #0080CB;
        background-color: #EEEEEE;
        margin: 0 10px;
        &:not(.disabled).active {
          color: #fff;
          background-color: #0080CB;
        }
      }
    }
  }
}


.hosIndex
  .head
    height 64px
    background #fff
    color #000
    z-index 99
    opacity 0.8
    width 100%
    position fixed
    top 0
    >div
      width 1200px
      margin 0 auto
      img
        height 48px
        float left
        margin-top 10px
      .login-ent
        a
          cursor pointer
          display inline-block
          float right
          height 64px
          width 140px
          line-height 64px
          color #000
          text-align center
          font-size 16px
  .navigation
    font-size 16px
    width 100%
    height 67px
    line-height 67px
    background #fff
    margin-top 64px
    >div
      width 1200px
      margin 0px auto
  .hos-head
    height 344px
    background #F6F8F9
    padding-top 36px
    >div
      height 308px
      background #fff
      width 1200px
      margin 0px auto
      display flex
      >div
        font-size 14px
        color #333333
        margin-top 32px
        width 800px
        >div
          &:nth-child(1)
            >div
              &:nth-child(1)
                width 630px
                span
                  &:nth-child(1)
                    font-size 30px
                    color #0080CB
                    margin-right 40px
                  &:nth-child(2)
                    font-size 16px
                    color #E92C38
              &:nth-child(2)
                margin-top 20px
          &:nth-child(2)
            color #0080CB
            font-size 20px
            margin-top 20px
            border-bottom 1px solid #DEDEDE
            width 80px
            padding-bottom 15px
          &:nth-child(3)
            line-height 30px
            margin-top 15px
            max-height: 120px;
            overflow-x: auto;
            padding-right: 20px;
          &:nth-child(3)::-webkit-scrollbar 
            /*滚动条整体样式*/
            width: 4px;
            /*高宽分别对应横竖滚动条的尺寸*/
            height: 4px;
          &:nth-child(3)::-webkit-scrollbar-thumb 
            /*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: rgba(0, 0, 0, 0.2);
           &:nth-child(3)::-webkit-scrollbar-track 
            /*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
          &:nth-child(4)
            display flex
            margin-top 10px
            >div
              &:nth-child(1)
                color #0080CB
                width 500px
                margin-top 5px
                img
                  height 10px
                  width 14px
              &:nth-child(2)
                display flex
                >div
                  width 100px
                  height 30px
                  line-height 30px
                  color #fff
                  border-radius 20px
                  margin-left 50px
                  &:nth-child(1)
                    background #02D081
                    img
                      width 11px
                      height 14px
                      margin 8px 8px 8px 12px
                  &:nth-child(2)
                    background #F9A821
                    img
                      width 15px
                      height 14px
                      margin 8px 8px 8px 10px
      >img
        width: 290px;
        height: 200px;
        margin: 40px 20px 0px 5px;
  .hos-content
    >div
      width 1200px
      margin 0 auto
      .tabs
        display flex
        margin-top 50px
        >div
          cursor pointer
          width 140px
          height 44px
          line-height 44px
          border 1PX solid #E9E9E9
          text-align center
          font-size 20px
          color #333
          &.active
            background #0080CB
            color #fff
      .hos-main
        display flex
        margin-bottom 150px
        .hos-main-left
          width 820px
          margin-right 60px
          .title
            font-size 22px
            color #0080CB
            margin 40px 0px 30px 0px
            position relative
            .more
              cursor pointer
              position absolute
              right 0px
              color #0080CB
              font-size 16px
              top 10px
              img
                width 14px
                height 10px
          .dept-list
            border 1PX solid #D4D4D4
            position relative
            padding 0 30px
            font-size 16px
            >div
              height 58px
              line-height 58px
              .dept-title
                display inline-block
                width 80px
                white-space nowrap
                margin-right 30px
                color #333
              .dept-name
                color #333
                font-weight bold
                margin-right 15px
              .dept-data
                color #0080CB
                font-size 18px
                line-height 31px
                font-family Source Han Sans CN
                font-weight 500
            .center-line
              width 90%
              height 1px
              border-bottom 1px solid #D4D4D4
              position absolute
              top 58px
              left 5%
          .doc-list
            >div
              float left
              width 260px
              height 186px
              background rgba(255, 255, 255, 1)
              box-shadow 0px 0px 8px rgba(229, 243, 249, 1)
              text-align center
              font-size 14px
              color #333
              padding 30px 0px
              margin 6px
              >div
                margin-top 15px
              img
                width 100px
                height 100px
                border-radius 50%
        .hos-main-right
          width 320px
          >div
            margin-bottom 20px
          .hos-right-head
            background #0080CB
            font-size 16px
            color #fff
            width 320px
            text-align center
            line-height 44px
            height 44px
          .content
            border 1PX solid #E9E9E9
            border-top 0px
          .hos-search
            .content
              background #F5F5F5
              height 80px
          .hos-navigation
            .content
              font-size 16px
              padding 30px
              color #666666
              >div
                margin-bottom 20px
              .map
                width 100%
                height 300px
                .anchorBL
                  display none
          .hos-cooperation
            .content
              padding 15px
              >div
                float left
                font-size 14px
                color #666666
                margin 15px
                &:last-child
                  float none
                  clear both
  .hos-HOS_DESC
    border 1PX solid #D4D4D4
    margin 40px 0px 85px 0px
    padding 40px
    font-size 16px
    line-height 30px
    text-indent 2em
.fade-enter-active, .fade-leave-active
  transition opacity 0.5s
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  opacity 0
.myfade-enter-active, .myfade-leave-active
  transition opacity 0.5s
.myfade-enter, .myfade-leave-to /* .myfade-leave-active below version 2.1.8 */
  opacity 0
</style>
